import { Card, Typography } from "antd";
import React from "react";
import useIsNurseMobile from "./useIsNurseMobile";

const ClinicalCard = ({ data }) => {
  const isNurseMobile = useIsNurseMobile();

  return (
    <Card
      className={`landing-summary-card${
        isNurseMobile ? " landing-clinical-card" : ""
      }`}
      title="Clinical Diagnosis"
      bordered
      styles={{ header: { borderBottom: "none" }, body: { paddingTop: "0px" } }}
    >
      <Typography>{data}</Typography>
    </Card>
  );
};

export default ClinicalCard;
// border: "1px solid #ccc"
